import React, { useState } from "react";
import { handleRequest } from "../utils/api";

function ResetPassword({ password, setPassword, setMessage }) {
  const [phone, setPhone] = useState(""); // 핸드폰 번호 상태

  const handleResetPassword = async () => {
    if (!password) {
      alert("비밀번호를 입력해주세요.");
      // setMessage("비밀번호를 입력해주세요.");
      return;
    }
    if (!phone) {
      alert("핸드폰 번호를 입력해주세요.");
      // setMessage("핸드폰 번호를 입력해주세요.");
      return;
    }

    const userConfirmed = window.confirm(
      `${phone} 회원의 비밀번호를 초기화하시겠습니까?`
    );
    if (!userConfirmed) {
      return;
    }

    try {
      console.log("password:", password);
      console.log("phone:", phone);
      const response = await handleRequest("/admin/passwordReset", {
        phone: phone,
        adminPassword: password,
      });
      const { status, message } = response;
      if (status === "error") {
        alert("에러: " + message);
        // setMessage("에러: " + message);
      } else {
        setPassword("");
        setPhone("");
        alert("비밀번호가 성공적으로 초기화되었습니다.");
        setMessage("");
        // setMessage("비밀번호가 성공적으로 초기화되었습니다.");
      }
    } catch (error) {
      console.error("비밀번호 초기화 요청 중 오류:", error);

      let errorMsg = "";
      if (error.response?.data?.error) {
        errorMsg = String(error.response.data.error);
      } else if (error.response?.data?.message) {
        errorMsg = String(error.response.data.message);
      } else if (error.message) {
        errorMsg = String(error.message);
      } else {
        errorMsg = "알 수 없는 오류가 발생했습니다.";
      }

      if (errorMsg && errorMsg.startsWith("No member found")) {
        setMessage("해당 휴대폰 번호에 해당하는 회원이 없습니다.");
      } else {
        setMessage("비밀번호 초기화 요청 중 오류가 발생했습니다: " + errorMsg);
      }
    }
  };

  return (
    <div className="reset-pw-area">
      <div className="sub-tit-area">
        <div className="dot-container">
          <span className="dot outer"></span>
          <span className="dot inner"></span>
        </div>
        <p>회원 비밀번호 초기화</p>
      </div>
      <div className="txt-area">
        <p>(00000000 으로 초기화 됩니다)</p>
      </div>
      <div className="input-area">
        <div className="input-wrapper">
          <span className="label body-n d-gray">
            핸드폰 번호&nbsp;&nbsp;&nbsp;&nbsp;|
          </span>
          <input
            type="text"
            id="password_phone"
            className="inp3 body-n"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>
      </div>
      <div className="button-area">
        <button className="solid m-button" onClick={handleResetPassword}>
          초기화
        </button>
      </div>
    </div>
  );
}

export default ResetPassword;
